import React from 'react';
import { useTranslation } from 'react-i18next';
import Wallet from '../Wallet';
import WithdrawModeToggler from '../WithdrawModeToggler';
import emptyCpayImage from '../../../img/cpay-svg/empty.svg';
import emptyNFGImage from '../../../img/nfgpay-svg/empty-nfg.svg';
import emptyFinvaroImage from '../../../img/finvaro/empty-finvaro.svg';
import emptyClarniumImage from '../../../img/clarnium/empty-clarnium.svg';
import emptyInexImage from '../../../img/inex/empty-inex.svg';
import emptyInstaImage from '../../../img/instaXchange/empty-insta.svg';
import emptyCoineraImage from '../../../img/coinera/empty-coinera.svg';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { identity } from '../../../utils/getIdentity';
import Button from '../../Button';
import './style.scss';

const emptyImage = {
  cpay: emptyCpayImage,
  nfg: emptyNFGImage,
  finvaro: emptyFinvaroImage,
  clarnium: emptyClarniumImage,
  inex: emptyInexImage,
  insta: emptyInstaImage,
  coinera: emptyCoineraImage
};

const WalletsList = ({
  withdrawWallets,
  walletsFetching,
  selectedWallet,
  setSelectedWallet,
  setFrom,
  setCurrency,
  multisendMode,
  setMultisendMode,
  walletListRef,
  currencies,
  currency,
  getLoadMoreWithdrawWallets,
  walletVersion,
  merchantId,
  networkFilter,
  countItem,
  page,
  pages
}) => {
  const { t } = useTranslation();

  const getWalletInfo = (id, address) => {
    setCurrency(id);
    setFrom(address);
  };

  return (
    <div className={`withdraw-wallets withdraw-wallets-${identity}`} ref={walletListRef}>
      <div className={`withdraw-wallets__title withdraw-wallets__title-${identity}`}>
        {t('admin.my_wallets')}
      </div>
      {!walletsFetching ? (
        <div className="withdraw-wallets__list">
          {withdrawWallets.length ? (
            withdrawWallets.map(wallet => (
              <Wallet
                key={wallet._id}
                wallet={wallet}
                selectedWallet={selectedWallet}
                setSelectedWallet={setSelectedWallet}
                getWalletInfo={getWalletInfo}
              />
            ))
          ) : (
            <div className="withdraw-wallets__empty">
              <span className="transactions-list__empty-title">{t('wallets.emptyList')}</span>
              <img src={emptyImage[identity]} className="transactions-list__empty-image" alt="empty" />
            </div>
          )}
          {+page < pages && (
            <Button
              className={`withdraw-wallets__load-more withdraw-wallets__load-more-${identity}`}
              onClick={() =>
                getLoadMoreWithdrawWallets(
                  merchantId,
                  currency,
                  networkFilter,
                  true,
                  true,
                  (page = +page + 1),
                  false,
                  walletVersion
                )
              }
            >
              Load more
            </Button>
          )}
          {/* {selectedWallet && (
            <button
              type="button"
              className={`withdraw-wallets__select withdraw-wallets__select-${identity}`}
              disabled={!selectedWallet}
              onClick={() => {
                setCurrency(selectedWallet._id);
                setFrom(selectedWallet.address);
              }}
            >
              {t('send')}
            </button>
          )} */}
        </div>
      ) : (
        <div className="withdraw-wallets__loader">
          <Spin indicator={<LoadingOutlined className={`spin-${identity}`} style={{ fontSize: 24 }} spin />} />
        </div>
      )}
    </div>
  );
};

export default WalletsList;
